// extracted by mini-css-extract-plugin
module.exports = {"root":"TopBackBar_root__GG3Qs"};